import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VERIFICATIONS_QUERY_KEY } from "Api/Queries/Verifications/useVerificationsQuery";
import { postVerifications } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useCreateVerificationsMutation = ({
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() => postVerifications()),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [VERIFICATIONS_QUERY_KEY],
      });
      onSuccess?.();
    },
    onError:
      onError || (() => toast.error(t(Resources.Hooks.Verifications.Error))),
  });
};
